// src/components/PermissionGate.jsx
//
// Conditionally renders children based on a permission codename.
// If the user doesn't have the permission, renders `fallback` instead
// (defaults to null — renders nothing).
//
// Usage examples:
//
//   // Hide a UI element entirely
//   <PermissionGate codename="download_reports">
//     <Button label="Download CSV" />
//   </PermissionGate>
//
//   // Show an "Access Denied" message instead
//   <PermissionGate codename="view_finance_dashboard" fallback={<AccessDenied />}>
//     <AccountingDashboard />
//   </PermissionGate>
//
//   // Redirect to home when used as a route guard (see App.js)
//   <PermissionGate codename="view_finance_dashboard" fallback={<Navigate to="/home" replace />}>
//     <AccountingDashboard />
//   </PermissionGate>

import { usePermission } from '../contexts/UserContext';

const PermissionGate = ({ codename, fallback = null, children }) => {
    const allowed = usePermission(codename);
    return allowed ? children : fallback;
};

export default PermissionGate;
